export default __webpack_public_path__ + "static/media/M29.8adb68df.svg";